import * as t from '../types';
import algoliasearch from 'algoliasearch/lite';

export const AlgoSearch = geoloc => async (dispatch, getState) => {
  const searchClient = algoliasearch(
    process.env.REACT_APP_algoliaAppKey,
    process.env.REACT_APP_algoliaAdminKey
  );

  if (geoloc !== 'clear') {
    const index = searchClient.initIndex(
      process.env.REACT_APP_algoliaIndexName
    );
    const result = await index.search('', {
      aroundLatLng: `${geoloc.lat},${geoloc.lng}`,
      aroundRadius: 1000000, // 10000 km
    });
    if (result.hits[0] !== undefined) {
      dispatch({ type: t.ALGO_SEARCH, payload: result.hits });
    }
  } else {
    dispatch({ type: t.ALGO_CLEAR });
  }

  //   if (geoloc === ' ') {
  //     dispatch({ type: t.ALGO_CLEAR });
  //   } else if (geoloc === undefined) {
  //     dispatch({ type: t.ALGO_CLEAR });
  //   } else if (geoloc === '') {
  //     dispatch({ type: t.ALGO_CLEAR });
  //   } else if (geoloc === null) {
  //     dispatch({ type: t.ALGO_CLEAR });
  //   } else {
  //     const result = await index.search(geoloc);
  //     // (result.hits);
  //     if (result.hits[0] !== undefined) {
  //       dispatch({ type: t.ALGO_SEARCH, payload: result.hits });
  //     }
  //   }
};
